import React, { useEffect, useState } from "react";
import { Link, NavLink, useLocation } from "react-router-dom";
import SocialSidebar from "./SocialSidebar";
import "./header.css";

const prefetchRoute = (route) => {
  switch (route) {
    case "/about-mmi":
    case "/history":
      import("../../pages/About/AboutMMI");
      break;
    case "/general-admin":
      import("../../pages/Administration/Administration");
      break;
    case "/our-presence":
    case "/african-province":
    case "/rome":
    case "/francis-province":
    case "/malawi":
    case "/papuva-new-guinea":
    case "/tanzanian":
      import("../../pages/OurPresence/OurPresence");
      break;
    case "/vocations":
      import("../../pages/Vocations/Vocations");
      break;
    case "/formation":
      import("../../pages/Formation/Formation");
      break;
    case "/sprituality":
      import("../../pages/Spiritual/Spiritual");
      break;
    case "/gallery":
      import("../../pages/Gallery/PhotoGallery");
      break;
    case "/blog":
      import("../../pages/Blog/Blog");
      break;
    case "/calendar":
      import("../../pages/Calendar/Calendar");
      break;
    default:
      break;
  }
};

function Header({ menudata }) {
  const location = useLocation();
  const [isScrolled, setIsScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      if (window.scrollY > 20) {
        setIsScrolled(true);
      } else {
        setIsScrolled(false);
      }
    };

    window.addEventListener("scroll", handleScroll, { passive: true });
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  return (
    <>
      <SocialSidebar />
      <header className="site-header">
        <div className="top-header-bar">
          <div className="container">
            <div className="row flex-wrap justify-content-center justify-content-lg-between align-items-lg-center">
              <div className="col-12 col-lg-12 d-none d-md-flex flex-wrap justify-content-center justify-content-lg-start mb-3 mb-lg-0">
                <div className="header-bar-email" style={{ fontSize: "13px" }}>
                  <>
                    <i
                      className="fa fa-envelope"
                      style={{ color: "#f6c93f" }}
                    ></i>
                    <a href={`mailto:mmisecgen@gmail.com`}>
                      <span
                        className="__cf_email__"
                        style={{ marginLeft: "0.5rem" }}
                      >
                        mmisecgen@gmail.com
                      </span>
                    </a>
                  </>
                </div>
                <div
                  className="header-bar-text align-items-center justify-content-center"
                  style={{ fontSize: "13px" }}
                >
                  <>
                    <i className="fa fa-phone" style={{ color: "#f6c93f" }}></i>
                    <a href={`tel:+91-9876543210`} style={{ marginLeft: "0.3rem" }}>
                      +91-9876543210
                    </a>
                  </>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="header-banner">
          <Link to="/" className="site-logo">
            <img
              src="/images/all-img/banner.PNG"
              alt="Banner"
              style={{ maxWidth: "100%", height: "auto", display: "block", margin: "0 auto" }}
              fetchPriority="high"
            />
          </Link>
        </div>
        <nav className={`navbar navbar-expand-lg navbar-light custom-menu ${isScrolled ? "is-scrolled" : ""}`}>
          <button
            className="navbar-toggler"
            type="button"
            data-toggle="collapse"
            data-target="#navbarNav"
            aria-controls="navbarNav"
            aria-expanded="false"
            aria-label="Toggle navigation"
          >
            <span className="navbar-toggler-icon"></span>
          </button>
          <div
            className="collapse navbar-collapse header-align-center"
            id="navbarNav"
          >
            <ul className="navbar-nav">
              {menudata?.map((menuItem, index) => (
                <li key={index} className={`nav-item ${menuItem.children ? "dropdown" : ""}`}>
                  {menuItem.children ? (
                    <NavLink
                      to={menuItem.url}
                      className="nav-link dropdown-toggle"
                      id="navbarDropdownMenuLink"
                      role="button"
                      data-toggle="dropdown"
                      aria-haspopup="true"
                      aria-expanded="false"
                      onMouseEnter={() => prefetchRoute(menuItem.url)}
                    >
                      {menuItem.label}
                    </NavLink>
                  ) : (
                    <Link
                      to={menuItem.url}
                      className={`nav-link ${location.pathname === menuItem.url ? "active" : ""}`}
                      onMouseEnter={() => prefetchRoute(menuItem.url)}
                    >
                      {menuItem.label}
                    </Link>
                  )}
                  {menuItem.children && (
                    <div className="dropdown-menu" aria-labelledby="navbarDropdownMenuLink">
                      {menuItem.children.map((subItem, subIndex) => (
                        <NavLink
                          key={subIndex}
                          to={subItem.url}
                          className="dropdown-item"
                          activeclassname="active"
                          onMouseEnter={() => prefetchRoute(subItem.url)}
                        >
                          {subItem.label}
                        </NavLink>
                      ))}
                    </div>
                  )}
                </li>
              ))}
            </ul>
          </div>
        </nav>
      </header>
    </>
  );
}

export default React.memo(Header);
